var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#CFA809",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3828 19.2773C31.2384 19.2773 33.5537 21.5416 33.5537 24.3343V30.3145C33.5537 33.1072 31.2384 35.3714 28.3828 35.3714H18.1319C15.2762 35.3714 12.9609 33.1072 12.9609 30.3145V24.3343C12.9609 21.5416 15.2762 19.2773 18.1319 19.2773H28.3828ZM23.2512 24.9349C22.6603 24.9349 22.1803 25.4044 22.1803 25.9822V28.6545C22.1803 29.2443 22.6603 29.7138 23.2512 29.7138C23.8543 29.7138 24.3344 29.2443 24.3344 28.6545V25.9822C24.3344 25.4044 23.8543 24.9349 23.2512 24.9349Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.9481 17.6809V19.4624C29.5173 19.342 29.0619 19.2818 28.5942 19.2818H27.7941V17.6809C27.7941 15.2373 25.7631 13.2511 23.2644 13.2511C20.7657 13.2511 18.7347 15.2252 18.7224 17.6568V19.2818H17.9346C17.4546 19.2818 16.9992 19.342 16.5684 19.4744V17.6809C16.5807 14.0696 19.5717 11.1445 23.2398 11.1445C26.9571 11.1445 29.9481 14.0696 29.9481 17.6809Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDuration);
export default __webpack_public_path__ + "static/media/lock-duration.156100e887ddb260669c291c9da20294.svg";
export { ForwardRef as ReactComponent };